export const getAnswer = (value: string | string[]): string =>
  Array.isArray(value) ? value.join(', ') : value
